import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { ClerkProvider } from '@clerk/clerk-react';
import './index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import reportWebVitals from './reportWebVitals';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT ?? process.env.NODE_ENV,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
  });
}

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error('Missing REACT_APP_CLERK_PUBLISHABLE_KEY in environment');
}

const clerkLocalization = {
  signIn: {
    start: {
      title: 'Anchor',
      subtitle: 'Ahoy! Sign in to your account',
    },
  },
  formFieldError__notFound: 'Signing in is not available yet; please navigate back to Salesforce and relaunch the One Pager application.',
  formFieldError__matchingPasswords: undefined,
  unstable__errors: {
    form_identifier_not_found: 'Signing in is not available yet; please navigate back to Salesforce and relaunch the One Pager application.',
  },
};

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element #root not found');
}

const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div>Something went wrong.</div>}>
      <ClerkProvider publishableKey={PUBLISHABLE_KEY} localization={clerkLocalization}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ClerkProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();
